const images = {
  products: {
    //Bags
    PSBG_439: require("../../assets/imgs/products/bags/PSBG_439.jpg"),
    PSBG_440: require("../../assets/imgs/products/bags/PSBG_440.jpg"),
    PSBG_441: require("../../assets/imgs/products/bags/PSBG_441.jpg"),
    PSBG_443: require("../../assets/imgs/products/bags/PSBG_443.jpg"),
    PSBG_444: require("../../assets/imgs/products/bags/PSBG_444.jpg"),
    PSBG_445: require("../../assets/imgs/products/bags/PSBG_445.jpg"),
    PSBG_446: require("../../assets/imgs/products/bags/PSBG_446.jpg"),
    PSBG_447: require("../../assets/imgs/products/bags/PSBG_447.jpg"),
    PSBG_450: require("../../assets/imgs/products/bags/PSBG_450.jpg"),
    PSBG_451: require("../../assets/imgs/products/bags/PSBG_451.jpg"),
    PSBG_453: require("../../assets/imgs/products/bags/PSBG_453.jpg"),
    PSBG_454: require("../../assets/imgs/products/bags/PSBG_454.jpg"),
    PSBG_455: require("../../assets/imgs/products/bags/PSBG_455.jpg"),
    PSBG_456: require("../../assets/imgs/products/bags/PSBG_456.jpg"),
    PSBG_457: require("../../assets/imgs/products/bags/PSBG_457.jpg"),
    PSBG_458: require("../../assets/imgs/products/bags/PSBG_458.jpg"),
    PSBG_459: require("../../assets/imgs/products/bags/PSBG_459.jpg"),
    PSBG_460: require("../../assets/imgs/products/bags/PSBG_460.jpg"),
    PSBG_461: require("../../assets/imgs/products/bags/PSBG_461.jpg"),


    //blouses-tops
    PSGR_3050: require("../../assets/imgs/products/blouses-tops/PSGR_3050.jpg"),
    PSGR_3051: require("../../assets/imgs/products/blouses-tops/PSGR_3051.jpg"),
    PSGR_3810: require("../../assets/imgs/products/blouses-tops/PSGR_3810.jpg"),
    PSGR_3811: require("../../assets/imgs/products/blouses-tops/PSGR_3811.jpg"),
    PSGR_3812: require("../../assets/imgs/products/blouses-tops/PSGR_3812.jpg"),
    PSGR_3813: require("../../assets/imgs/products/blouses-tops/PSGR_3813.jpg"),
    PSGR_3852: require("../../assets/imgs/products/blouses-tops/PSGR_3852.jpg"),
    PSGR_3866: require("../../assets/imgs/products/blouses-tops/PSGR_3866.jpg"),
    PSGR_3919: require("../../assets/imgs/products/blouses-tops/PSGR_3919.jpg"),
    PSGR_3923: require("../../assets/imgs/products/blouses-tops/PSGR_3923.jpg"),
    PSGR_4111: require("../../assets/imgs/products/blouses-tops/PSGR_4111.jpg"),
    PSGR_4113: require("../../assets/imgs/products/blouses-tops/PSGR_4113.jpg"),
    PSGR_4114: require("../../assets/imgs/products/blouses-tops/PSGR_4114.jpg"),
    PSGR_4116: require("../../assets/imgs/products/blouses-tops/PSGR_4116.jpg"),
    PSGR_4133_COL_2: require("../../assets/imgs/products/blouses-tops/PSGR_4133_COL-2.jpg"),
    PSGR_4133_COL_1: require("../../assets/imgs/products/blouses-tops/PSGR_4133_COL-1.jpg"),
    PSGR_4133_COL_3: require("../../assets/imgs/products/blouses-tops/PSGR_4133_COL-3.jpg"),
    PSGR_4134: require("../../assets/imgs/products/blouses-tops/PSGR_4134.jpg"),
    PSGR_4182: require("../../assets/imgs/products/blouses-tops/PSGR_4182.jpg"),
    PSGR_4185: require("../../assets/imgs/products/blouses-tops/PSGR_4185.jpg"),
    PSGR_4377: require("../../assets/imgs/products/blouses-tops/PSGR_4377.jpg"),
    PSGR_4379: require("../../assets/imgs/products/blouses-tops/PSGR_4379.jpg"),
    PSGR_4384: require("../../assets/imgs/products/blouses-tops/PSGR_4384.jpg"),
    PSGR_4405: require("../../assets/imgs/products/blouses-tops/PSGR_4405.jpg"),


    //scarves
    PS_5771_PA: require("../../assets/imgs/products/scarves/PS_5771_PA.jpg"),
    PS_5772_PA: require("../../assets/imgs/products/scarves/PS_5772_PA.jpg"),
    PS_5773_PA: require("../../assets/imgs/products/scarves/PS_5773_PA.jpg"),
    PS_5774_ST: require("../../assets/imgs/products/scarves/PS_5774_ST.jpg"),
    PS_5775_PA: require("../../assets/imgs/products/scarves/PS_5775_PA.jpg"),
    PS_5776_PA: require("../../assets/imgs/products/scarves/PS_5776_PA.jpg"),
    PS_5778_PA: require("../../assets/imgs/products/scarves/PS_5778_PA.jpg"),
    PS_5779_PA: require("../../assets/imgs/products/scarves/PS_5779_PA.jpg"),
    PS_6029_PA: require("../../assets/imgs/products/scarves/PS_6029_PA.jpg"),
    PS_6030_PA: require("../../assets/imgs/products/scarves/PS_6030_PA.jpg"),
    PS_6031_PA: require("../../assets/imgs/products/scarves/PS_6031_PA.jpg"),
    PS_6032_PA: require("../../assets/imgs/products/scarves/PS_6032_PA.jpg"),
    PS_6033_PA: require("../../assets/imgs/products/scarves/PS_6033_PA.jpg"),
    PS_6178_SC: require("../../assets/imgs/products/scarves/PS_6178_SC.jpg"),
    PS_6179_SC: require("../../assets/imgs/products/scarves/PS_6179_SC.jpg"),
    PS_6180_SC: require("../../assets/imgs/products/scarves/PS_6180_SC.jpg"),
    PS_6181_SC: require("../../assets/imgs/products/scarves/PS_6181_SC.jpg"),
    PS_6183_SC: require("../../assets/imgs/products/scarves/PS_6183_SC.jpg"),
    PS_6184_SC: require("../../assets/imgs/products/scarves/PS_6184_SC.jpg"),
    PS_6185_SC: require("../../assets/imgs/products/scarves/PS_6185_SC.jpg"),
    PS_6186_SC: require("../../assets/imgs/products/scarves/PS_6186_SC.jpg"),
    PS_6187_SC: require("../../assets/imgs/products/scarves/PS_6187_SC.jpg"),
    PS_6213_SC: require("../../assets/imgs/products/scarves/PS_6213_SC.jpg"),
    PS_6214_SC: require("../../assets/imgs/products/scarves/PS_6214_SC.jpg"),
    PS_6215_SC: require("../../assets/imgs/products/scarves/PS_6215_SC.jpg"),
    PS_6216_SC: require("../../assets/imgs/products/scarves/PS_6216_SC.jpg"),
    PS_6431_SC_A: require("../../assets/imgs/products/scarves/PS_6431_SC_A.jpg"),
    PS_6431_SC_B: require("../../assets/imgs/products/scarves/PS_6431_SC_B.jpg"),
    PS_6431_SC_C: require("../../assets/imgs/products/scarves/PS_6431_SC_C.jpg"),
    PS_6431_SC: require("../../assets/imgs/products/scarves/PS_6431_SC.jpg"),
    PS_6450_ST: require("../../assets/imgs/products/scarves/PS_6450_ST.jpg"),
    PS_6451_ST: require("../../assets/imgs/products/scarves/PS_6451_ST.jpg"),
    PS_6452_ST: require("../../assets/imgs/products/scarves/PS_6452_ST.jpg"),
    PS_6453_SC: require("../../assets/imgs/products/scarves/PS_6453_SC.jpg"),
    PS_6454_SC: require("../../assets/imgs/products/scarves/PS_6454_SC.jpg"),
    PS_6455_SC: require("../../assets/imgs/products/scarves/PS_6455_SC.jpg"),
    PS_6462_B: require("../../assets/imgs/products/scarves/PS_6462_B.jpg"),
    PS_6462_C: require("../../assets/imgs/products/scarves/PS_6462_C.jpg"),
    PS_6462_SC_A: require("../../assets/imgs/products/scarves/PS_6462_SC_A.jpg"),
    PS_6462_SC: require("../../assets/imgs/products/scarves/PS_6462_SC.jpg"),

    // shirt dresses

    PSGR_3898: require("../../assets/imgs/products/shirt-dress/PSGR_3898.jpg"),
    PSGR_3901: require("../../assets/imgs/products/shirt-dress/PSGR_3901.jpg"),
    PSGR_3914: require("../../assets/imgs/products/shirt-dress/PSGR_3914.jpg"),
    PSGR_3930: require("../../assets/imgs/products/shirt-dress/PSGR_3930.jpg"),
    PSGR_3952: require("../../assets/imgs/products/shirt-dress/PSGR_3952.jpg"),
    PSGR_4150: require("../../assets/imgs/products/shirt-dress/PSGR_4150.jpg"),
    PSGR_4152: require("../../assets/imgs/products/shirt-dress/PSGR_4152.jpg"),
    PSGR_4184: require("../../assets/imgs/products/shirt-dress/PSGR_4184.jpg"),
    PSGR_4186: require("../../assets/imgs/products/shirt-dress/PSGR_4186.jpg"),
    PSGR_4187: require("../../assets/imgs/products/shirt-dress/PSGR_4187.jpg"),
    PSGR_4190: require("../../assets/imgs/products/shirt-dress/PSGR_4190.jpg"),
    PSGR_4191: require("../../assets/imgs/products/shirt-dress/PSGR_4191.jpg"),
    PSGR_4193: require("../../assets/imgs/products/shirt-dress/PSGR_4193.jpg"),
    PSGR_4195: require("../../assets/imgs/products/shirt-dress/PSGR_4195.jpg"),
    PSGR_4197: require("../../assets/imgs/products/shirt-dress/PSGR_4197.jpg"),
    PSGR_4369: require("../../assets/imgs/products/shirt-dress/PSGR_4369.jpg"),
    PSGR_4600: require("../../assets/imgs/products/shirt-dress/PSGR_4600.jpg"),
    PSGR_4617: require("../../assets/imgs/products/shirt-dress/PSGR_4617.jpg"),
    PSGR_4647: require("../../assets/imgs/products/shirt-dress/PSGR_4647.jpg"),
    PSGR_4648: require("../../assets/imgs/products/shirt-dress/PSGR_4648.jpg"),
    PSGR_4649: require("../../assets/imgs/products/shirt-dress/PSGR_4649.jpg"),

    // dresses
    BCW_884: require("../../assets/imgs/products/dresses/BCW_884.jpg"),
    BCW_885: require("../../assets/imgs/products/dresses/BCW_885.jpg"),
    BCW_886: require("../../assets/imgs/products/dresses/BCW_886.jpg"),
    BCW_888: require("../../assets/imgs/products/dresses/BCW_888.jpg"),
    BCW_890: require("../../assets/imgs/products/dresses/BCW_890.jpg"),
    BCW_892: require("../../assets/imgs/products/dresses/BCW_892.jpg"),
    BCW_906: require("../../assets/imgs/products/dresses/BCW_906.jpg"),
    BCW_907: require("../../assets/imgs/products/dresses/BCW_907.jpg"),
    BCW_915: require("../../assets/imgs/products/dresses/BCW_915.jpg"),
    BCW_916: require("../../assets/imgs/products/dresses/BCW_916.jpg"),
    BCW_923: require("../../assets/imgs/products/dresses/BCW_923.jpg"),
    BCW_930: require("../../assets/imgs/products/dresses/BCW_930.jpg"),
    BCW_933: require("../../assets/imgs/products/dresses/BCW_933.jpg"),
    BCW_941: require("../../assets/imgs/products/dresses/BCW_941.jpg"),
    BCW_947: require("../../assets/imgs/products/dresses/BCW_947.jpg"),
    BCW_962: require("../../assets/imgs/products/dresses/BCW_962.jpg"),
    BCW_963: require("../../assets/imgs/products/dresses/BCW_963.jpg"),
    BCW_971: require("../../assets/imgs/products/dresses/BCW_971.jpg"),
    BCW_989: require("../../assets/imgs/products/dresses/BCW_989.jpg"),
    BCW_996B: require("../../assets/imgs/products/dresses/BCW_996B.jpg"),
    BCW_1006B: require("../../assets/imgs/products/dresses/BCW_1006B.jpg"),
    BCW_1014B: require("../../assets/imgs/products/dresses/BCW_1014B.jpg"),
    BCW_1016B: require("../../assets/imgs/products/dresses/BCW_1016B.jpg"),
    BCW_1017B: require("../../assets/imgs/products/dresses/BCW_1017B.jpg"),
    BCW_1018B: require("../../assets/imgs/products/dresses/BCW_1018B.jpg"),
    BCW_1056B: require("../../assets/imgs/products/dresses/BCW_1056B.jpg"),
    BCW_1058B: require("../../assets/imgs/products/dresses/BCW_1058B.jpg"),
    BCW_1132B: require("../../assets/imgs/products/dresses/BCW_1132B.jpg"),
    BCW_1134B: require("../../assets/imgs/products/dresses/BCW_1134B.jpg"),
    BCW_1136B: require("../../assets/imgs/products/dresses/BCW_1136B.jpg"),
    BCW_1138B: require("../../assets/imgs/products/dresses/BCW_1138B.jpg"),
    BCW_1139B: require("../../assets/imgs/products/dresses/BCW_1139B.jpg"),
    BCW_1341: require("../../assets/imgs/products/dresses/BCW_1341.jpg"),


    //pants

    PSGR_2964: require("../../assets/imgs/products/pants/PSGR_2964.jpg"),
    PSGR_2965: require("../../assets/imgs/products/pants/PSGR_2965.jpg"),
    PSGR_3954: require("../../assets/imgs/products/pants/PSGR_3954.jpg"),
    PSGR_3964: require("../../assets/imgs/products/pants/PSGR_3964.jpg"),
    PSGR_3965: require("../../assets/imgs/products/pants/PSGR_3965.jpg"),
    PSGR_4042: require("../../assets/imgs/products/pants/PSGR_4042.jpg"),
    PSGR_4076: require("../../assets/imgs/products/pants/PSGR_4076.jpg"),
    PSGR_4159: require("../../assets/imgs/products/pants/PSGR_4159.jpg"),
    PSGR_4163: require("../../assets/imgs/products/pants/PSGR_4163.jpg"),
    PSGR_4165: require("../../assets/imgs/products/pants/PSGR_4165.jpg"),
    PSGR_4280: require("../../assets/imgs/products/pants/PSGR_4280.jpg"),
    PSGR_4382: require("../../assets/imgs/products/pants/PSGR_4382.jpg"),
    PSGR_5166: require("../../assets/imgs/products/pants/PSGR_5166.jpg"),

    // skirts


    PSGR_3967: require("../../assets/imgs/products/skirts/PSGR_3967.jpg"),
    PSGR_3968: require("../../assets/imgs/products/skirts/PSGR_3968.jpg"),
    PSGR_3970: require("../../assets/imgs/products/skirts/PSGR_3970.jpg"),
    PSGR_4054: require("../../assets/imgs/products/skirts/PSGR_4054.jpg"),
    PSGR_4126: require("../../assets/imgs/products/skirts/PSGR_4126.jpg"),
    PSGR_4346: require("../../assets/imgs/products/skirts/PSGR_4346.jpg"),
    PSGR_4412: require("../../assets/imgs/products/skirts/PSGR_4412.jpg"),
    PSGR_4414: require("../../assets/imgs/products/skirts/PSGR_4414.jpg"),
    PSGR_4612: require("../../assets/imgs/products/skirts/PSGR_4612.jpg"),
    PSGR_4614: require("../../assets/imgs/products/skirts/PSGR_4614.jpg"),
    PSGR_4615: require("../../assets/imgs/products/skirts/PSGR_4615.jpg"),
    PSGR_4616: require("../../assets/imgs/products/skirts/PSGR_4616.jpg"),
    PSGR_5063: require("../../assets/imgs/products/skirts/PSGR_5063.jpg"),
    PSGR_5077: require("../../assets/imgs/products/skirts/PSGR_5077.jpg"),
    PSGR_5078: require("../../assets/imgs/products/skirts/PSGR_5078.jpg"),
    PSGR_5082: require("../../assets/imgs/products/skirts/PSGR_5082.jpg"),
    PSGR_5095: require("../../assets/imgs/products/skirts/PSGR_5095.jpg"),
    PSGR_5121: require("../../assets/imgs/products/skirts/PSGR_5121.jpg"),
    PSGR_5149: require("../../assets/imgs/products/skirts/PSGR_5149.jpg"),
    PSGR_5165: require("../../assets/imgs/products/skirts/PSGR_5165.jpg"),
    PSGR_5183: require("../../assets/imgs/products/skirts/PSGR_5183.jpg"),

  },
  categories: {
    bags: require("../../assets/imgs/categories/bags.jpg"),
    blouses: require("../../assets/imgs/categories/blouses.jpg"),
    scarves: require("../../assets/imgs/categories/scarves.jpg"),
    shirtdress: require("../../assets/imgs/categories/shirtdress.jpg"),
    dresses: require("../../assets/imgs/categories/dresses.jpg"),
    skirts: require("../../assets/imgs/categories/skirts.jpg"),
    pants: require("../../assets/imgs/categories/paints.jpg")
  },
  homeCategories: {
    bags: require("../../assets/imgs/categories/homeCategory/bags.jpg"),
    blouses: require("../../assets/imgs/categories/homeCategory/blouses.jpg"),
    scarves: require("../../assets/imgs/categories/homeCategory/scarves.jpg"),
    shirtdress: require("../../assets/imgs/categories/homeCategory/shirtdress.jpg"),
    dresses: require("../../assets/imgs/categories/homeCategory/dresses.jpg"),
    skirts: require("../../assets/imgs/categories/homeCategory/skirts.jpg"),
    pants: require("../../assets/imgs/categories/homeCategory/paints.jpg")
  }
};

export default images;
